module.exports = __webpack_public_path__ + "static/media/ConnectWalletButton.314b57ff.png";